import {
	StyleSettingsImageUploaderActionTypes,
	TStyleSettingsImageUploaderAction,
} from './StyleSettingsImageUploaderActions';
import { IStyleSettingsImageUploaderState } from './styleSettingsImageUploaderContext';

export const styleSettingsImageUploaderReducer = (
	state: IStyleSettingsImageUploaderState,
	action: TStyleSettingsImageUploaderAction,
): IStyleSettingsImageUploaderState => {
	switch (action.type) {
		case StyleSettingsImageUploaderActionTypes.SET_LOADING:
			return {
				...state,
				isLoading: action.payload.isLoading,
			};
		case StyleSettingsImageUploaderActionTypes.SET_UPLOADER_SRC:
			return {
				...state,
				uploaderSrc: action.payload.src,
			};
		case StyleSettingsImageUploaderActionTypes.SET_CROPPER_SRC:
			return {
				...state,
				cropperSrc: action.payload.src,
			};
		case StyleSettingsImageUploaderActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case StyleSettingsImageUploaderActionTypes.CHANGE_TYPE_OF_ERROR_MODAL_WINDOW:
			return {
				...state,
				typeOfErrorModalWindow: action.payload.typeOfErrorModalWindow,
			};
		case StyleSettingsImageUploaderActionTypes.SET_LOADING_IMAGE_ERROR:
			return {
				...state,
				loadingImageError: action.payload.loadingImageError,
			};
		case StyleSettingsImageUploaderActionTypes.SET_NEW_IMAGE_UPLOADED:
			return {
				...state,
				isNewImageUploaded: action.payload.isNewImageUploaded,
			};
		default:
			return state;
	}
};
